import { Actions } from "../../../../components/Actions/Actions";
import { useOrderActions } from "../../../../hooks";
import { EmailModal } from "./EmailModal";

interface OrderActionsSectionProps {
	orderNumber: string;
}

export const OrderActionsSection = ({ orderNumber }: OrderActionsSectionProps): JSX.Element => {
	const { actions, isEmailModalOpen, hideEmailModal } = useOrderActions(orderNumber);

	return (
		<div data-testid="e-order-order-actions-section">
			<Actions actions={actions} />
			<EmailModal isEmailModalOpen={isEmailModalOpen} hideEmailModal={hideEmailModal} />
		</div>
	);
};
